const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallFeature(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 4.82843H18.6566M18.6566 4.82843L16.5352 6.94975M18.6566 4.82843L16.5352 2.70711",
    style: {
      fill: "none",
      stroke: "#3B5AA9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1211 6.94967L21.2424 4.82835L19.1211 2.70703",
    style: {
      fill: "none",
      stroke: "#3B5AA9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5559 14.548L15.1009 15.028C15.1009 15.028 14.0179 16.167 11.0629 13.056C8.10786 9.94505 9.19086 8.80605 9.19086 8.80605L9.47786 8.50305C10.1839 7.75905 10.2509 6.56505 9.63386 5.69305L8.37386 3.91005C7.60986 2.83005 6.13486 2.68805 5.25986 3.60905L3.69086 5.26005C3.25786 5.71705 2.96786 6.30805 3.00286 6.96505C3.09286 8.64505 3.81086 12.258 7.81486 16.475C12.0619 20.945 16.0469 21.123 17.6759 20.962C18.1919 20.912 18.6399 20.633 19.0009 20.253L20.4209 18.757C21.3809 17.747 21.1109 16.017 19.8829 15.311L17.9729 14.211C17.1669 13.748 16.1859 13.884 15.5559 14.547",
    style: {
      fill: "#3B5AA9",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFeature);
export default __webpack_public_path__ + "static/media/callFeature.c2b15e14645d91300f6443c0c7ed02ec.svg";
export { ForwardRef as ReactComponent };